// @ts-strict-ignore
import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'

import { aboutImages, advantageCardItems, joinData, subscribeItems, whyCardItems } from '@/screens/SpaceIport/page/data'
import { AdvantageCard } from '@/screens/SpaceIport/page/ui/AdvantageCard/AdvantageCard'
import { SpaceInfo } from '@/screens/SpaceIport/page/ui/SpaceInfo/SpaceInfo'
import { SpaceJoin } from '@/screens/SpaceIport/page/ui/SpaceJoin/SpaceJoin'
import { SpaceSlider } from '@/screens/SpaceIport/page/ui/SpaceSlider/SpaceSlider'
import { WhyCard } from '@/screens/SpaceIport/page/ui/WhyCard/WhyCard'

import { useMediaQueries } from '@/shared/lib/hooks/useMediaQueries'
import { Banner } from '@/shared/ui/Banner/Banner'
import { FullWidthWrap } from '@/shared/ui/FullWidthWrap'

import SubscribeLine from './ui/SubscribeLine/SubscribeLine'

import styles from './Space.module.scss'

export const SpacePage: FC = () => {
	const { isMobile } = useMediaQueries()

	return (
		<main>
			<section className={styles.section}>
				<FullWidthWrap>
					<Banner
						imgSrcDesk={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/hero-desk.jpg'}
						imgSrcMob={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/hero-mob.jpg'}
						imgDeskWidth={1920}
						imgDeskHeight={600}
						imgMobWidth={750}
						imgMobHeight={720}
						style={{ borderRadius: '0' }}
						maxWidth="uset"
					/>
				</FullWidthWrap>
			</section>

			<section className={clsx(styles.section)}>
				<h2 className={styles.title}>Почему iPort</h2>
				<div className={styles.sectionWhy}>
					{whyCardItems.map((item, index) => (
						<WhyCard
							key={index}
							iconSrc={item.iconSrc}
							iconSrcHover={item.iconSrcHover}
							title={item.title}
							subtitle={item.subtitle}
						/>
					))}
				</div>
				<Link prefetch={false} className={styles.sectionLink} href="/catalog">
					Перейти в каталог
				</Link>
			</section>

			<section className={styles.section}>
				<h2 className={styles.title}>Преимущества</h2>
				<div className={styles.sectionAdv}>
					{advantageCardItems.map((item, index) => (
						<AdvantageCard
							key={index}
							title={item.title}
							subtitle={item.subtitle}
							backgroundImage={item.backgroundImage}
							subtitleColor={item.subtitleColor}
						/>
					))}
				</div>
				<Link prefetch={false} className={styles.sectionLink} href="/shops">
					Найти магазин
				</Link>
			</section>

			<FullWidthWrap
				style={{
					backgroundImage: `url(https://storage.yandexcloud.net/tf-bitrix-upload/iport/space-page-new/slider-bg.jpg)`
				}}>
				{/*<section className={clsx(styles.section, styles.info)}>*/}
				<SpaceSlider />
				{/*</section>*/}
			</FullWidthWrap>

			<div className={styles.section} />

			<section className={styles.section}>
				<h2 className={styles.title}>О компании</h2>
				<p className={styles.subtitle}>
					NBCom Group — это группа компаний, в которую входят сети фирменных магазинов iPort, Samsung, Huawei, а также
					сервисные центры iPort и Samsung.
				</p>
				<ul className={styles.about}>
					{aboutImages.map((image, index) => (
						<li key={index}>
							<Image
								src={image.src}
								width={isMobile ? image.mobileWidth : image.width}
								height={isMobile ? image.mobileHeight : image.height}
								alt={image.alt}
								priority
							/>
						</li>
					))}
				</ul>
			</section>

			<FullWidthWrap style={{ backgroundColor: `#F6F6F6` }}>
				<section className={clsx(styles.section, styles.info)}>
					<SpaceInfo />
				</section>
			</FullWidthWrap>

			<div className={styles.section} />

			<section className={styles.section}>
				<Banner
					imgSrcDesk={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/screens/loyalty/banner-1.png'}
					imgSrcTablet={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/screens/loyalty/banner-1.png'}
					imgSrcMob={'https://storage.yandexcloud.net/tf-bitrix-upload/iport/screens/loyalty/banner.png'}
					imgDeskWidth={1420}
					imgDeskHeight={540}
					imgTabletWidth={1420}
					imgTabletHeight={540}
					imgMobWidth={720}
					imgMobHeight={1300}
					title="Программа лояльности для всех сетей NBCom Group"
					style={{ borderRadius: '25px' }}
					link="/services/iport-card/"
				/>
			</section>

			<section className={styles.section}>
				<h2 className={styles.title}>Мы в социальных сетях</h2>
				<SubscribeLine items={subscribeItems} />
			</section>
			<section className={styles.section}>
				<SpaceJoin {...joinData} />
			</section>

			<section className={clsx(styles.section, styles.bottomLinks)}>
				<Link prefetch={false} className={styles.sectionLink} href="/catalog" target="_blank">
					Перейти в каталог
				</Link>
				<Link prefetch={false} className={styles.sectionLink} href="/shops" target="_blank">
					Найти магазин
				</Link>
			</section>
		</main>
	)
}
